import {Trans} from '@lingui/macro';
import React from 'react';

import {useToggle} from '../../../../srcCommon/helpers/hookHelpers';
import {TriggerWithConditions} from '../ruleTriggerHelpers';
import {EditorStateActions} from './hooks/useEditorState';
import {RuleEditorSection} from './ruleEditorSection';
import {RuleTriggersList} from './ruleTriggersList';

/*
 * Types.
 */

interface RuleEditorTriggersProps {
  triggers: ReadonlyArray<TriggerWithConditions>;
  notDisplayingErrorCards?: ReadonlyArray<string>;

  onAddTrigger: EditorStateActions['onAddTrigger'];
  onUpdateTrigger: EditorStateActions['onUpdateTrigger'];
  onDeleteTrigger: EditorStateActions['onDeleteTrigger'];
  onValidation: EditorStateActions['onValidation'];
}

/*
 * Component.
 */

export const RuleEditorTriggers = (props: RuleEditorTriggersProps) => {
  const [shouldShowMoreOptions, toggleMoreOptions] = useToggle();
  const {triggers, notDisplayingErrorCards, onAddTrigger, onUpdateTrigger, onDeleteTrigger, onValidation} =
    props;

  return (
    <RuleEditorSection
      description={<Trans id="rules-editor-section-header-when">When…</Trans>}
      shouldShowMoreOptions={shouldShowMoreOptions}
      toggleMoreOptions={toggleMoreOptions}
    >
      <RuleTriggersList
        selectedTriggers={triggers}
        notDisplayingErrorCards={notDisplayingErrorCards}
        shouldShowMoreOptions={shouldShowMoreOptions}
        onAddTrigger={onAddTrigger}
        onUpdateTrigger={onUpdateTrigger}
        onDeleteTrigger={onDeleteTrigger}
        onValidation={onValidation}
      />
    </RuleEditorSection>
  );
};
